/** @jsxImportSource @emotion/react */
import React from 'react'
import estyled from '@signal/theme/emotion'
import { makeStyles } from '@material-ui/core/styles'
import MuiAlert from '@material-ui/lab/Alert'
import MUISnackbar from '@material-ui/core/Snackbar'
import { snackbarZIndexSelector } from '@signal/theme/selectors'

export const Alert = props => (
  <MuiAlert elevation={6} variant="filled" {...props} />
)

export const Snackbar = estyled(MUISnackbar)`
  z-index: ${snackbarZIndexSelector};
`

export const useStyles = makeStyles({
  toastrAlertIcon: {
    marginTop: 4
  },
  toastrTypographyRoot: {
    fontWeight: 'bold'
  }
})
